import { useEffect, useState } from 'react';
import React from 'react';
import { toast } from 'react-toastify';

import { useTranslation } from 'react-i18next';
import {  getAllCertifications } from '../../services/certifications';
import { Breadcrumb, BreadcrumbItem} from 'reactstrap';
import './certifications.css';
import LoadingScreen from 'src/Loading/LoadingScreen';
interface Certification {
    id: number;
    name: string;
    issuer: string;
    date: string;
}

export default function CertificationsList() {
    const [certifications, setCertifications] = useState<Certification[]>([]);
    const [pageNo, setPageNo] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const perPage = 9;
    const {t}=useTranslation();
    const [loading, setLoading] = useState(true);


    const getCertifications = async () => {
        setLoading(true);
        try {
            const response :any= await getAllCertifications('', perPage, pageNo);

            if(response.success){
                setCertifications(response.data);
                setTotalPages(response.totalPages); 
            }
            else{
                toast.error(response.message);
                console.error('Error fetching certifications:', response.message);
            }
        } catch (error) {
            toast.error('Error fetching certifications');
            console.error('Error fetching certifications:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
       getCertifications()
    }, [pageNo]);


    if (loading) {
        return (
          <div className="loading-screen" 
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
                         <div><LoadingScreen/></div>
                       </div>
        );
      }
   

    return (
        <div className="root">
           
                <>
                  

                    <div className="d-flex justify-content-between align-items-center mb-lg">
                <h4 className=" px-3">{t("Certifications.page_title_certifications")}</h4>
                <div>
             
             
                </div>
              </div>



              
                <div className="container_info rounded border-Card " style={{ padding: '40px 20px', backgroundColor: 'var(--widget-bg)' }}>
                    <div className="container">
                        <div className="row">
                           
                        {certifications.map((card: any) => (
              <div className="col-lg-4 col-md-12 mb-4" key={card.id}>
                <div
                  className="card card-margin"
                  style={{ marginBottom: '20px', cursor: 'pointer' }}
                  onClick={() => setSelectedImage(`${process.env.REACT_APP_API_URL}${card.src}?public=true`)} 
                >
                  <div className="card-header no-border d-flex justify-content-between align-items-center">
                    <h5 className="card-title">{card.name}</h5>
                  </div>
                  <div className="card-body pt-0">
                    <div className="widget-49 pt-3">
                      <img
                        style={{ width: '100%', height: '100%' }}
                        src={`${process.env.REACT_APP_API_URL}${card.src}?public=true`}
                        alt={card.name}
                        className="card-img-top"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
                        </div>
                           {certifications.length === 0 && 
                (
                  <div className="">
                    <p  className="text-center alert alert-warning ">
                    {t("Compliance_Page.No_available_data")}
                    </p>
                  </div>
              )}
                    </div>

                    {/* Pagination */}
                    <div className="pagination-controls mt-5">
                        <button
                            className="btn btn-warning btn-sm text-white"
                            onClick={() => setPageNo(1)}
                            disabled={pageNo ===0}
                        >
                            {"<<"}
                        </button>{" "}
                        <button
                            className="btn btn-warning btn-sm text-white"
                            onClick={() => setPageNo((prev) => Math.max(prev - 1,0))}
                            disabled={pageNo === 0}
                        >
                            {"<"}
                        </button>{" "}
                        <button
                            className="btn btn-warning btn-sm text-white"
                            onClick={() =>
                                setPageNo((prev) =>
                                    Math.min(
                                        prev + 1,
                                        totalPages-1
                                    )
                                )
                            }
                            disabled={
                                pageNo >= totalPages-1 
                            }
                        >
                            {">"}
                        </button>{" "}
                        <button
                            className="btn btn-warning btn-sm text-white"
                            onClick={() =>
                                setPageNo(
                                    totalPages-1 
                                )
                            }
                            disabled={
                                pageNo >= totalPages-1 
                            }
                        >
                            {">>"}
                        </button>{" "}
                        <span>
                            {t("Governance_Page.page")}
                            {pageNo+1} {t("Governance_Page.to")} {totalPages}
                        </span>
                    </div>

                        {/* Bootstrap Modal */}
                        {selectedImage && (
          <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="btn-close" onClick={() => setSelectedImage(null)}></button>
                </div>
                <div className="modal-body text-center">
                  <img src={selectedImage} alt="Certification" style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
              </div>
            </div>
          </div>
        )}
                </div>
            </>
        </div>
    );
}
